export const xlsxMimeTypes = [
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];
